export const CONTACT = {
  email: "evoltroppus@gmail.com",
  phone: "(555) 012-3456",
  phoneRaw: "+15550123456",
  instagram: "https://instagram.com/evolandtroppus",
  linkedin: "https://linkedin.com/company/evol-troppus",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1761658652336-95d31ce1d806?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjYWxtJTIwZmFtaWx5JTIwbW9kZXJuJTIwaG9tZXxlbnwwfHx8fDE3ODY5MTM4NDV8MA&ixlib=rb-4.1.0&q=85",
  consultation: "https://images.unsplash.com/photo-1733685373532-e67c3f68786a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBjb25zdWx0YXRpb24lMjBtaW5pbWFsaXN0fGVufDB8fHx8MTc4NjkxMzg0Nnww&ixlib=rb-4.1.0&q=85",
  architecture: "https://images.unsplash.com/photo-1528759094033-e86a2379be5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMHdhcm0lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg2OTEzODQ2fDA&ixlib=rb-4.1.0&q=85",
  leaf: "https://images.unsplash.com/photo-1573519716358-1cdc98533bfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxzYWdlJTIwZ3JlZW4lMjBuYXR1cmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NjkxMzg0Nnww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "parent-coaching",
    title: "Parent Coaching",
    icon: "HeartHandshake",
    short: "Helping caregivers better understand behavior, communication, routines, reinforcement, and daily challenges using evidence-informed strategies.",
    tagline: "Practical strategies for real family life",
    overview: [
      "Parent coaching at Evol & Troppus is a collaborative, educational partnership. We help you understand what everyday behavior is communicating, then build practical strategies that fit your family's values, routines, and capacity.",
      "This is coaching, not clinical treatment — we do not diagnose, assess, or prescribe. We help you make sense of the guidance you already have, fill in the gaps with evidence-informed education, and turn good advice into daily habits.",
    ],
    benefits: [
      "A clear understanding of the why behind everyday behavior",
      "Strategies grounded in evidence, delivered with compassion",
      "Live coaching and feedback, not just theory",
      "Confidence carrying out recommendations from your child's providers",
      "A judgment-free space to ask anything",
    ],
    whoFor: [
      "Parents and caregivers feeling stuck in daily power struggles",
      "Families navigating a new autism or ADHD diagnosis",
      "Caregivers who want to understand their child's behavior plan",
      "Anyone tired of advice that does not survive contact with real life",
    ],
    faqs: [
      { q: "Is parent coaching therapy?", a: "No. Coaching is educational, not clinical. We do not diagnose, treat, or replace medical, psychological, or ABA services. We help you understand behavior and consistently apply practical strategies at home — working alongside, never instead of, your child's providers." },
      { q: "Do you offer virtual sessions?", a: "Yes. All parent coaching is available virtually, which means we can support you in the environment where life actually happens — your home." },
      { q: "How many sessions will we need?", a: "It depends on your goals. Many families feel meaningful shifts within 4–8 sessions. We review progress together and adjust as we go." },
    ],
  },
  {
    slug: "home-routine-coaching",
    title: "Home Routine Coaching",
    icon: "Sunrise",
    short: "Helping families build practical routines for mornings, homework, bedtime, transitions, toileting, independence, and daily living skills.",
    tagline: "Calmer days start with better systems",
    overview: [
      "The hardest parts of family life are usually the most predictable — which means they are designable. Home Routine Coaching maps your real day, finds the friction points, and rebuilds them step by step: visual supports, priming, reinforcement, and routines that fit your child's needs and your family's capacity.",
      "Because we are coaching you, progress does not depend on a professional being in the room. You learn the strategies, we help you refine them, and the routines keep working long after our sessions end.",
    ],
    benefits: [
      "Calmer mornings, bedtimes, and transitions",
      "Visual supports and checklists tailored to your home",
      "Step-by-step plans for independence and daily living skills",
      "Strategies aligned with your child's existing therapy goals",
      "Systems simple enough to keep using on your busiest days",
    ],
    whoFor: [
      "Families whose mornings or bedtimes feel like a daily battle",
      "Caregivers working on toileting, hygiene, or self-help skills",
      "Parents who want more independence for their child — and themselves",
      "Families already in therapy who want help applying strategies at home",
    ],
    faqs: [
      { q: "How is this different from parent coaching?", a: "Parent Coaching builds your overall understanding of behavior. Home Routine Coaching is laser-focused on specific daily routines — we pick the hardest parts of your day and redesign them together, step by step." },
      { q: "Will this conflict with our child's therapy?", a: "No — it is designed to complement it. We align with the goals and recommendations of your child's existing providers and help you implement them consistently at home." },
      { q: "Do you come to our home?", a: "Most routine coaching happens virtually, which lets us work with real moments as they happen. In-person availability depends on your location — ask during your discovery call." },
    ],
  },
  {
    slug: "school-collaboration",
    title: "School Collaboration Support",
    icon: "School",
    short: "Helping families prepare for meetings, organize communication with teachers, understand recommendations from their child's providers, and advocate confidently.",
    tagline: "One child, one team",
    overview: [
      "Children do best when the adults around them row in the same direction. We help you prepare for school meetings, organize communication with teachers, and make sense of recommendations from your child's providers — so you can walk into every conversation informed and confident.",
      "We translate between clinical and educational language, help you ask the right questions, and support consistency between home and school. We do not write IEPs or clinical plans — we help you understand and carry out the ones your child's team creates.",
    ],
    benefits: [
      "Confident preparation for IEP, 504, and teacher meetings",
      "Organized, productive communication with school staff",
      "Plain-language explanations of provider recommendations",
      "Consistent strategies shared between home and classroom",
      "A calmer, more collaborative advocacy experience",
    ],
    whoFor: [
      "Families preparing for IEP or 504 meetings",
      "Parents who feel unheard or overwhelmed in school settings",
      "Caregivers trying to keep home and school strategies consistent",
      "Families who want help understanding reports and recommendations",
    ],
    faqs: [
      { q: "Do you attend school meetings with us?", a: "Our focus is preparing you to walk in confident — organizing your questions, documents, and goals beforehand and debriefing afterward. Virtual meeting support may be available depending on your situation." },
      { q: "Do you write behavior plans or IEP goals?", a: "No. Those are created by your child's clinical and educational teams. We help you understand them, ask informed questions, and carry out strategies consistently at home." },
    ],
  },
  {
    slug: "virtual-coaching",
    title: "Virtual Family Coaching",
    icon: "Video",
    short: "Personalized virtual coaching sessions focused on helping caregivers implement consistent strategies at home while working alongside their child's therapy team.",
    tagline: "Support without the commute",
    overview: [
      "Virtual Family Coaching brings the full Evol & Troppus approach to your screen. Sessions happen over secure video, scheduled around your family's life — including evenings — so support fits into your week instead of disrupting it.",
      "Remote does not mean distant. We coach in real time, review situations together, and stay connected between sessions — always in step with your child's existing therapy team.",
    ],
    benefits: [
      "Flexible scheduling, including evenings",
      "Coaching in your actual home environment",
      "Session summaries you can share with providers",
      "Between-session messaging for quick questions",
    ],
    whoFor: [
      "Families outside our local area",
      "Busy caregivers who need evening options",
      "Anyone who prefers support from home",
      "Families who want continuity alongside existing therapy",
    ],
    faqs: [
      { q: "Is virtual coaching effective?", a: "For caregiver coaching, yes — research supports virtual parent-mediated coaching, and it lets us work in the environment where routines actually happen." },
      { q: "What technology do we need?", a: "Just a device with a camera and a stable internet connection. We handle the rest." },
    ],
  },
  {
    slug: "resource-library",
    title: "Resource Library",
    icon: "Library",
    href: "/resources",
    short: "Downloadable guides, templates, trackers, and educational materials for caregivers.",
    tagline: "Free tools for everyday wins",
    overview: [
      "Our Resource Library is a growing collection of printable guides, visual schedule templates, trackers, and educational handouts — the same practical frameworks we use in coaching, free for caregivers to download and use at home.",
      "Every resource is designed to make evidence-informed strategies easier to apply consistently in everyday life, and to complement the work of your child's existing providers.",
    ],
    benefits: [
      "Free, printable guides and templates",
      "Visual supports ready to adapt to your routines",
      "Trackers that turn confusion into useful patterns",
      "New materials added as the library grows",
    ],
    whoFor: [
      "Caregivers who want practical tools right now",
      "Families waiting to start services",
      "Teachers and providers looking for family-friendly handouts",
      "Anyone who learns best with something in hand",
    ],
    faqs: [
      { q: "Are the resources really free?", a: "Yes. The library is our way of making practical, evidence-informed tools available to every caregiver — no cost, no catch." },
      { q: "Can I share them with my child's team?", a: "Please do. They are designed to be shared with teachers, therapists, and anyone supporting your child." },
    ],
  },
];

export const WHY_US = [
  { icon: "FlaskConical", title: "Evidence-informed", text: "Every strategy we share is grounded in research and shaped by hands-on experience — no trends, no guesswork." },
  { icon: "ShieldCheck", title: "Trauma-informed", text: "We assume history matters. Safety, trust, and assent come before any intervention." },
  { icon: "Sparkles", title: "Neurodiversity-affirming", text: "We support people, not compliance. Difference is respected, never trained away." },
  { icon: "Users", title: "Collaborative", text: "You are the expert on your family. We bring the science; together we build the plan." },
  { icon: "Wrench", title: "Practical", text: "Strategies designed for Tuesday at 6pm — not just the therapy room." },
  { icon: "Home", title: "Family-centered", text: "Change sticks when it fits your family's values, culture, and real capacity." },
];

export const PROCESS_STEPS = [
  { icon: "CalendarCheck", title: "Schedule Consultation", text: "Start with a conversation. We listen first — to your goals, your concerns, and what has already been tried." },
  { icon: "ClipboardList", title: "Personalized Plan", text: "Together we build a plan around your family's real routines, values, and capacity — not a template." },
  { icon: "MessagesSquare", title: "Ongoing Coaching", text: "Regular sessions with live feedback, adjustments, and support between meetings when life happens." },
  { icon: "TrendingUp", title: "Sustainable Success", text: "The goal is independence: skills and systems that keep working long after our sessions end." },
];

export const TESTIMONIALS = [
  {
    quote: "For the first time, someone explained why the meltdowns were happening instead of just telling us to be more consistent. Our evenings are unrecognizable.",
    name: "Sarah M.",
    role: "Parent of two",
  },
  {
    quote: "The consultation was thorough, compassionate, and genuinely useful. Our school team finally has a plan everyone understands and believes in.",
    name: "Daniel R.",
    role: "Special Education Director",
  },
  {
    quote: "No judgment, no jargon — just clear strategies that respected our daughter and actually worked. We felt understood from the very first call.",
    name: "Priya & James K.",
    role: "Coaching family",
  },
];

export const HOME_FAQS = [
  { q: "What ages do you work with?", a: "We coach caregivers of children from toddlerhood through adolescence. Because our work is with you — the adult — our approach adapts to your child's developmental stage, not just their diagnosis." },
  { q: "Do you take insurance?", a: "Our educational coaching services are private-pay, which keeps them flexible and family-directed. We can discuss pricing and options during your free discovery call." },
  { q: "Is everything virtual?", a: "Virtual coaching is available everywhere. In-person availability depends on location — reach out and we will let you know what is possible in your area." },
  { q: "How is this different from ABA therapy?", a: "We do not replace ABA therapy — we complement it. Evol & Troppus provides educational coaching and caregiver support: helping you understand behavior, implement strategies consistently at home, and work confidently alongside your child's existing providers." },
  { q: "What if we are not sure which service we need?", a: "That is exactly what the free 15-minute discovery call is for. We will listen, ask a few questions, and point you toward the right support — even if that is not us." },
  { q: "Is your approach neurodiversity-affirming?", a: "Yes. We do not work to make children appear neurotypical. We build skills, communication, and environments that help people thrive as themselves." },
  { q: "What are your qualifications?", a: "Evol & Troppus is founded and led by a certified Behavior Technician (BT/RBT) with years of hands-on experience working directly with children and families in home and school settings. We provide education, coaching, and implementation guidance — not diagnosis, assessment, or clinical treatment — and we are committed to lifelong learning and evidence-informed practice." },
];

export const CONSULTATION_TYPES = [
  {
    id: "discovery",
    icon: "Phone",
    title: "Free 15-Minute Discovery Call",
    duration: "15 min",
    price: "Free",
    text: "A short, pressure-free conversation to learn whether our coaching and caregiver support is a good fit for your family.",
  },
  {
    id: "parent-coaching",
    icon: "HeartHandshake",
    title: "Parent Coaching Consultation",
    duration: "50 min",
    price: "Paid",
    text: "A deep dive into your family's routines and challenges, leaving you with initial strategies you can use right away.",
  },
  {
    id: "home-routine",
    icon: "Sunrise",
    title: "Home Routine Coaching Consultation",
    duration: "50 min",
    price: "Paid",
    text: "Focused support for mornings, homework, bedtime, transitions, toileting, and daily living skills — practical plans for everyday life.",
  },
  {
    id: "school",
    icon: "School",
    title: "School Collaboration Consultation",
    duration: "50 min",
    price: "Paid",
    text: "Prepare for school meetings, organize communication with teachers, and understand provider recommendations so you can advocate confidently.",
  },
];

export const BOOKING_FAQS = [
  { q: "How long is a consultation?", a: "Discovery calls run 15 minutes. Full consultations run 30–60 minutes depending on the type you choose. We will never rush a conversation that matters." },
  { q: "What happens after I book?", a: "You will receive a confirmation email with a secure video link and a short intake form. Completing the form ahead of time helps us make every minute of your session count." },
  { q: "What will I receive after the consultation?", a: "A written summary of what we discussed, initial recommendations, and a clear proposal for next steps — whether that is coaching, consultation, or a referral elsewhere." },
  { q: "Can I reschedule?", a: "Yes. Life happens — you can reschedule or cancel up to 24 hours before your session using the link in your confirmation email." },
];

export const VALUES = [
  { num: "01", title: "Evidence-Informed Practice", text: "Science is our foundation. Every strategy we share is grounded in research and shaped by hands-on experience — but we never let rigor crowd out humanity." },
  { num: "02", title: "Collaboration", text: "Lasting change is built with people, never done to them. Families, teachers, and teams are partners in every decision we make together." },
  { num: "03", title: "Empowerment", text: "Our job is to make ourselves unnecessary. We teach skills and systems so the people we serve own their progress long after we leave." },
  { num: "04", title: "Compassion", text: "Behavior is communication. We start with understanding — of the child, the caregiver, and the context — before we change anything at all." },
  { num: "05", title: "Long-Term Independence", text: "Success is not a good week. It is a family that thrives on its own systems, years later. We design everything with that horizon in mind." },
];

export const BLOG_CATEGORIES = [
  "Parent Coaching",
  "ABA",
  "Autism",
  "ADHD",
  "Behavior Strategies",
  "Emotional Regulation",
  "Executive Functioning",
  "Professional Development",
];

export const BLOG_POSTS = [
  {
    slug: "reduce-morning-meltdowns",
    title: "5 Ways to Reduce Morning Meltdowns",
    excerpt: "Mornings compress every hard thing — transitions, time pressure, sensory demands — into forty-five minutes. Here is how to redesign them.",
    category: "Behavior Strategies",
    date: "2026-06-18",
    readTime: "6 min read",
    body: [
      { type: "p", text: "If mornings are the hardest part of your day, you are not alone. Morning routines stack nearly every known trigger for challenging behavior: waking before the body is ready, rapid transitions, time pressure, sensory demands like clothing and toothbrushing, and the looming separation of the school day." },
      { type: "p", text: "The good news: because mornings are predictable, they are also designable. Small structural changes tend to outperform willpower every time." },
      { type: "h2", text: "1. Move decisions to the night before" },
      { type: "p", text: "Every choice in the morning costs regulation. Clothes, breakfast options, and backpack contents can all be settled the evening before, when everyone has more capacity. Lay out two acceptable outfits and let your child pick between them — choice preserved, conflict avoided." },
      { type: "h2", text: "2. Build a visual sequence" },
      { type: "p", text: "A simple visual schedule — pictures or words on the bathroom mirror — offloads the remembering from your child and the nagging from you. When the schedule is the boss, you get to be the ally standing beside them instead of the voice hurrying them along." },
      { type: "h2", text: "3. Protect a buffer" },
      { type: "p", text: "Most families plan mornings to the minute, which means one slow shoe-tying derails everything. Wake the household fifteen minutes earlier than the math says you need. The calm is worth more than the sleep." },
      { type: "h2", text: "4. Front-load connection" },
      { type: "p", text: "Two minutes of undivided attention at wake-up — a cuddle, a shared joke, sitting together while they wake — pays dividends all morning. Children who feel connected are measurably more cooperative in the hour that follows." },
      { type: "h2", text: "5. Audit the sensory load" },
      { type: "p", text: "Tags, seams, toothpaste flavors, the sound of the hairdryer — sensory discomfort often masquerades as defiance. Watch for patterns, ask curious questions, and swap what you can. A seamless sock is not a small thing." },
      { type: "p", text: "Pick one of these to start. Mornings do not need to be perfect — they need to be survivable, then gradually, peaceful." },
    ],
  },
  {
    slug: "reinforcement-vs-bribery",
    title: "Reinforcement vs. Bribery: What's the Difference?",
    excerpt: "One builds skills and motivation. The other quietly backfires. The difference is not what you offer — it is when and how.",
    category: "Parent Coaching",
    date: "2026-06-10",
    readTime: "7 min read",
    body: [
      { type: "p", text: "Few questions come up in coaching more often than this one: \"If I offer my child a reward for behaving, am I bribing them?\" It is a fair worry, and the answer matters more than most parenting debates." },
      { type: "h2", text: "The technical difference" },
      { type: "p", text: "Reinforcement is planned in advance and delivered after a behavior: \"When your shoes are on, you can choose the car music.\" Bribery is negotiated in the moment of escalation: \"If you stop screaming, I'll buy you the toy.\"" },
      { type: "p", text: "The distinction is not pedantic. Reinforcement teaches that meeting expectations leads to good things. Bribery accidentally teaches that escalation leads to negotiation." },
      { type: "h2", text: "Why bribery backfires" },
      { type: "p", text: "When a child is mid-meltdown and we offer something desirable to stop the storm, the storm itself becomes the thing that produced the reward. Over time, escalations can become more frequent, not less — not because your child is manipulative, but because behavior follows its consequences." },
      { type: "h2", text: "Using reinforcement well" },
      { type: "p", text: "Set expectations before the hard moment. Keep rewards small, immediate, and mostly social — praise, choices, and shared activities outperform stuff. And fade them gradually as the skill becomes natural." },
      { type: "h2", text: "A word on worry" },
      { type: "p", text: "Parents sometimes fear that reinforcement means children will only behave for rewards. In practice, well-used reinforcement fades into habit and pride. Nobody needs a sticker to brush their teeth as an adult — but many of us learned with one." },
    ],
  },
  {
    slug: "understanding-adhd-beyond-attention",
    title: "Understanding ADHD Beyond Attention",
    excerpt: "ADHD is not a deficit of attention — it is a difference in regulation. Reframing it changes how we support kids who have it.",
    category: "ADHD",
    date: "2026-05-28",
    readTime: "8 min read",
    body: [
      { type: "p", text: "Ask most people what ADHD is and they will say something about paying attention. But watch a child with ADHD build Lego for three uninterrupted hours and the story gets more interesting. The challenge is not a lack of attention — it is the regulation of attention, emotion, and effort." },
      { type: "h2", text: "Interest, not importance, drives the ADHD brain" },
      { type: "p", text: "Most brains can engage effort because a task is important. ADHD brains engage effort when a task is interesting, novel, urgent, or personally meaningful. This is why a child can be 'incapable' of homework but encyclopedic about dinosaurs." },
      { type: "h2", text: "Emotional regulation is part of the picture" },
      { type: "p", text: "Many children with ADHD experience emotions quickly and intensely — and recover slowly. What looks like overreaction is often a nervous system with a hair trigger and long brakes. Support means building regulation skills, not demanding suppression." },
      { type: "h2", text: "Time blindness is real" },
      { type: "p", text: "\"Five more minutes\" means little to a brain that experiences time as 'now' and 'not now.' Externalizing time — visual timers, countdown cues, music playlists that mark transitions — works far better than reminders." },
      { type: "h2", text: "What helps" },
      { type: "p", text: "Make tasks shorter and feedback faster. Build movement into the day on purpose instead of punishing it. Externalize anything invisible: time, steps, expectations. And protect the relationship — children who feel chronically corrected stop believing they are capable." },
      { type: "p", text: "ADHD support works best when we stop asking 'how do I make them focus like other kids?' and start asking 'how do I design this so their brain can succeed?'" },
    ],
  },
  {
    slug: "building-independence-without-power-struggles",
    title: "Building Independence Without Power Struggles",
    excerpt: "Every parent wants a capable, independent child. The path there is paved with graduated choices — not battles of will.",
    category: "Parent Coaching",
    date: "2026-05-15",
    readTime: "6 min read",
    body: [
      { type: "p", text: "Independence is the quiet goal underneath almost everything we teach. Yet the road there often runs straight through power struggles — the shirt refusal, the homework standoff, the bedtime summit negotiations." },
      { type: "h2", text: "Control is the currency of childhood" },
      { type: "p", text: "Children control very little of their lives: what they wear, when they sleep, where they go, what they eat. When control is scarce, children protect it fiercely. Many power struggles are not about the task at all — they are about autonomy." },
      { type: "h2", text: "The two-choice technique" },
      { type: "p", text: "Offer two options you can genuinely live with: \"Do you want to do homework before snack or after?\" The boundary holds; the autonomy is real. This one shift dissolves a surprising share of daily battles." },
      { type: "h2", text: "Scaffold, then step back" },
      { type: "p", text: "Independence grows through graduated support: first we do it together, then we supervise, then we check in, then we simply trust. Skipping steps breeds failure; never releasing them breeds dependence. The art is in the fading." },
      { type: "h2", text: "Let natural consequences teach" },
      { type: "p", text: "When safety allows, reality is the best instructor. A forgotten jacket on a cool day teaches more than ten reminders. Our job is to keep the consequences survivable and the empathy genuine — \"that was a hard way to learn\" lands better than \"I told you so.\"" },
    ],
  },
  {
    slug: "what-to-expect-during-parent-coaching",
    title: "What to Expect During Parent Coaching",
    excerpt: "No judgment, no jargon, no generic scripts. A look inside what actually happens in a coaching engagement.",
    category: "Parent Coaching",
    date: "2026-05-02",
    readTime: "5 min read",
    body: [
      { type: "p", text: "Starting parent coaching can feel vulnerable. You are inviting someone into the hardest parts of your family life. Knowing what to expect helps — so here is an honest look at how coaching with us works." },
      { type: "h2", text: "The first session is mostly listening" },
      { type: "p", text: "We start with your story: what is hard, what you have tried, what a good week would look like. We ask about routines, stress points, and strengths — yours and your child's. You will not be judged. Most parents tell us the first session alone felt like exhaling." },
      { type: "h2", text: "You leave every session with something to try" },
      { type: "p", text: "Coaching is not abstract. Each session ends with one or two concrete strategies to practice before we meet again. Small, specific, doable — the kind that survive a chaotic Tuesday." },
      { type: "h2", text: "We review data, not feelings of failure" },
      { type: "p", text: "When something does not work, that is information, not a verdict. We adjust the plan together. Some strategies need three drafts before they fit a family's real life, and that is normal." },
      { type: "h2", text: "The goal is goodbye" },
      { type: "p", text: "Success in coaching looks like needing us less. As your confidence and systems grow, sessions space out — and eventually, you graduate with skills that belong to you permanently." },
    ],
  },
  {
    slug: "emotional-regulation-co-regulation",
    title: "Co-Regulation Comes Before Self-Regulation",
    excerpt: "Children borrow our nervous systems before they can use their own. What that means for how you respond to big feelings.",
    category: "Emotional Regulation",
    date: "2026-04-20",
    readTime: "7 min read",
    body: [
      { type: "p", text: "We often ask children to \"calm down\" as if calm were a choice they are refusing. Neurologically, self-regulation is a skill built over years — and it is built through thousands of experiences of co-regulation first." },
      { type: "h2", text: "Borrowed calm" },
      { type: "p", text: "A dysregulated child cannot be reasoned with, lectured, or punished into regulation. Their thinking brain is offline. What helps is a regulated adult: a slow voice, a low body, a steady presence. Calm is contagious — so is chaos." },
      { type: "h2", text: "What co-regulation looks like" },
      { type: "p", text: "Lower your voice instead of raising it. Get below eye level. Say less — five words or fewer during the storm: \"I'm here. You're safe.\" Save the teaching for later, when the thinking brain is back online." },
      { type: "h2", text: "Regulate yourself first" },
      { type: "p", text: "This is the hardest part. Your child's meltdown will find every button you have. A slow exhale before you respond is not a luxury — it is the intervention. You cannot pour calm from an empty nervous system." },
      { type: "h2", text: "Debrief later, briefly" },
      { type: "p", text: "Once everyone is regulated — often an hour later or the next day — a short, warm recap builds the skill: what happened, what we might try next time. Two minutes, no lecture. That is how co-regulation slowly becomes self-regulation." },
    ],
  },
  {
    slug: "supporting-executive-function-at-home",
    title: "Supporting Executive Function at Home",
    excerpt: "Planning, starting, shifting, remembering — the brain's management system can be supported with smart external structure.",
    category: "Executive Functioning",
    date: "2026-04-08",
    readTime: "6 min read",
    body: [
      { type: "p", text: "Executive function is the brain's management team: starting tasks, holding steps in mind, shifting between activities, inhibiting impulses, planning ahead. In children — especially those with ADHD — this team is still in training." },
      { type: "h2", text: "Externalize what is invisible" },
      { type: "p", text: "If a skill lives in the brain and the brain is still building it, move it outside: visual schedules, labeled bins, written morning checklists, timers. External structure is not a crutch — it is scaffolding that comes down as the building goes up." },
      { type: "h2", text: "Shrink the start" },
      { type: "p", text: "Task initiation is often the biggest bottleneck. \"Clean your room\" is paralyzing; \"put the books on the shelf\" is startable. Break tasks until the first step is too small to resist, and let momentum do the rest." },
      { type: "h2", text: "Practice transitions on purpose" },
      { type: "p", text: "Shifting between activities is an executive skill, and it can be rehearsed. Warnings at ten, five, and two minutes, paired with a visual timer, teach the brain to prepare for change instead of being ambushed by it." },
      { type: "h2", text: "Model out loud" },
      { type: "p", text: "Narrate your own management system: \"I need to remember the forms, so I'm putting them by the keys.\" Children absorb the strategies they hear — this is how internal dialogue is born." },
    ],
  },
  {
    slug: "trauma-informed-behavior-support",
    title: "What Trauma-Informed Behavior Support Actually Means",
    excerpt: "It is more than a buzzword. It is a fundamental reordering of how we read behavior and design help.",
    category: "Professional Development",
    date: "2026-03-25",
    readTime: "8 min read",
    body: [
      { type: "p", text: "\"Trauma-informed\" appears on every brochure now, which is exactly why it deserves a careful definition. Done well, it changes everything about how we assess behavior and design support. Done poorly, it is wallpaper." },
      { type: "h2", text: "From 'what is wrong with you?' to 'what happened to you?'" },
      { type: "p", text: "Trauma-informed practice starts with the assumption that behavior makes sense in context. A child who explodes at transitions may be protecting themselves, not challenging you. That reframe changes the intervention from control to safety." },
      { type: "h2", text: "Safety precedes learning" },
      { type: "p", text: "A nervous system scanning for threat cannot absorb new skills. Before any teaching plan, we ask: does this child feel safe here — with these people, in this environment? If not, building safety is the first intervention, not a prerequisite to skip." },
      { type: "h2", text: "Assent and choice as design features" },
      { type: "p", text: "Trauma-informed support builds in real choice, respects withdrawal of assent, and treats 'no' as information. This does not lower expectations — it raises engagement, because people invest in plans they helped shape." },
      { type: "h2", text: "It applies to teams, too" },
      { type: "p", text: "Staff carrying their own stress cannot co-regulate others. Trauma-informed organizations support their people with the same compassion they ask staff to extend to clients. Burnout is a systems problem, not a character flaw." },
    ],
  },
];

export const RESOURCE_CATEGORIES = [
  "Parent Guides",
  "Behavior Tips",
  "Visual Supports",
  "Recommended Books",
];

export const RESOURCES = [
  {
    id: "morning-routine-checklist",
    title: "Morning Routine Checklist",
    description: "A printable step-by-step morning sequence to reduce friction, off-load remembering, and start the day calmly.",
    category: "Parent Guides",
    file: "/resources/morning-routine-checklist.pdf",
    icon: "Sun",
  },
  {
    id: "visual-schedule-template",
    title: "Visual Schedule Template",
    description: "A flexible, ready-to-fill visual schedule framework you can adapt for home routines, transitions, and new skills.",
    category: "Visual Supports",
    file: "/resources/visual-schedule-template.pdf",
    icon: "LayoutList",
  },
  {
    id: "token-economy-starter-kit",
    title: "Token Economy Starter Kit",
    description: "Everything you need to launch a fair, motivating token system — rules, pitfalls, and a printable tracking board.",
    category: "Behavior Tips",
    file: "/resources/token-economy-starter-kit.pdf",
    icon: "Coins",
  },
  {
    id: "behavior-observation-log",
    title: "Behavior Observation Log",
    description: "A simple ABC (antecedent–behavior–consequence) log that turns confusing patterns into clear, useful data.",
    category: "Behavior Tips",
    file: "/resources/behavior-observation-log.pdf",
    icon: "NotebookPen",
  },
  {
    id: "positive-reinforcement-guide",
    title: "Parent Guide to Positive Reinforcement",
    description: "What reinforcement really is, why it is not bribery, and how to use it to build skills that last.",
    category: "Parent Guides",
    file: "/resources/positive-reinforcement-guide.pdf",
    icon: "BookOpen",
  },
  {
    id: "recommended-reading-list",
    title: "Recommended Reading List",
    description: "Our curated shelf: evidence-based books on behavior, parenting, autism, and ADHD that we recommend most often.",
    category: "Recommended Books",
    file: "/resources/recommended-reading-list.pdf",
    icon: "Library",
  },
];

export const FAQ_PAGE_GROUPS = [
  {
    title: "General",
    items: HOME_FAQS.slice(0, 3),
  },
  {
    title: "Services & Approach",
    items: [
      { q: "What is parent coaching, exactly?", a: "A collaborative, educational partnership where we help you understand behavior and build practical strategies for your specific family. It is coaching and education — not therapy, assessment, or treatment." },
      { q: "Who delivers your services?", a: "All coaching is delivered by our founder, a certified Behavior Technician (BT/RBT) with years of hands-on experience working directly with children and families. We provide education and implementation guidance, and we collaborate with — never replace — your child's existing providers." },
      { q: "Do you work with children directly?", a: "Our model works primarily with caregivers, because that is where lasting change lives. We do not provide direct therapy or clinical services — we help you carry your child team's recommendations into everyday life." },
      { q: "Do you diagnose or write behavior plans?", a: "No. We do not diagnose, conduct Functional Behavior Assessments, or write Behavior Intervention Plans. Those belong with licensed clinicians and BCBAs — our role is helping you understand and implement their guidance consistently at home." },
      ...HOME_FAQS.slice(5),
    ],
  },
  {
    title: "Booking & Logistics",
    items: [
      ...BOOKING_FAQS,
      { q: "Where are you located?", a: "We coach families virtually everywhere. In-person availability varies by region — contact us and we will confirm what is possible near you." },
    ],
  },
];

export const DISCLAIMER =
  "Evol & Troppus provides educational coaching and caregiver support. These services are not a substitute for medical, psychological, or clinical ABA services. We collaborate with families and existing providers to support consistent implementation in everyday life.";
